var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"dot",style:({ 'border': '5px solid ' + _vm.color, color: _vm.color })}),_c('span',[_vm._v(" "+_vm._s(_vm.department.name)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }